const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/segments.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/segments.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { AdminDashboardSegmentsSkeleton } from '@/features/admin-dashboard/components/AdminDashboardSegmentsSkeleton';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { mcapSegmentSearchQuery } from '@/features/mcap/services/segmentQueries';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Supervisor → Segment. Unlike Footage, a blank term lists all visible segments,
 * so the loader warms the empty-term first page — this route owns the initial
 * loading skeleton (`pendingComponent`) and cold-load error (`errorComponent`).
 * Search changes keep the previous page visible while the new query loads.
 */
export const Route = createFileRoute('/_authenticated/_app/supervisor/segments')({
  beforeLoad: requireCapabilities(has => has('assets.list')),
  loader: ({
    context
  }) => context.queryClient.ensureInfiniteQueryData(mcapSegmentSearchQuery('')),
  pendingComponent: AdminDashboardSegmentsSkeleton,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});